import * as yup from 'yup';
import { QUEUEID } from './queue-id-constants';

export interface FormData {
  name: string;
  phoneNumber: string;
  isCustomer: string;
  subject: string;
  injurySubject: string;
}

yup.setLocale({
  mixed: {
    required: 'Dette felt er obligatorisk'
  }
});

export const validationSchema = (formData: FormData) => {
  return yup.object().shape({
    name: yup.string().required(),
    phoneNumber: yup.string().required(),
    isCustomer: yup.string().required(),
    subject: yup.string().required(),
    injurySubject:
      formData.subject === 'injury' ? yup.string().required() : yup.string()
  });
};

export const to = (body: any) => {
  if (body.subject === QUEUEID.SundhedsForsikring) {
    return 'sundhed-info@gjensidige.dk';
  }
};

export default validationSchema;
